import { render, staticRenderFns } from "./CustomerDetail-customerAttachments.vue?vue&type=template&id=4e1f3c56&scoped=true"
import script from "./CustomerDetail-customerAttachments.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-customerAttachments.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-customerAttachments.vue?vue&type=style&index=0&id=4e1f3c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f3c56",
  null
  
)

export default component.exports